import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { articles } from '@/mocks/articles';
import arts from '@/mocks/zh/articles';

const articleImages: Record<string, string> = {
  'article-guide-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20professional%20illustration%20with%20warm%20cream%20and%20golden%20tones%2C%20soft%20geometric%20patterns%2C%20clean%20modern%20corporate%20aesthetic%2C%20premium%20luxurious%20brand%20visual%2C%20subtle%20texture%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-guide-01&orientation=landscape',
  'article-security-01': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20shield%20and%20lock%20themed%20illustration%20with%20warm%20amber%20and%20cream%20colors%2C%20soft%20geometric%20shapes%2C%20clean%20corporate%20style%2C%20trustworthy%20and%20secure%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-security-01&orientation=landscape',
  'article-news-01': 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20upgrade%20and%20innovation%20themed%20illustration%20with%20warm%20golden%20gradients%2C%20clean%20corporate%20style%2C%20modern%20and%20fresh%20aesthetic%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-news-01&orientation=landscape',
  'article-faq-01': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20question%20mark%20and%20dialogue%20themed%20illustration%20with%20soft%20warm%20tones%2C%20geometric%20clean%20design%2C%20friendly%20and%20helpful%20vibe%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-faq-01&orientation=landscape',
  'article-service-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20headset%20and%20support%20themed%20illustration%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20geometric%20design%2C%20professional%20corporate%20style%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-service-01&orientation=landscape',
  'article-exp-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20star%20and%20review%20themed%20illustration%20with%20warm%20golden%20tones%2C%20soft%20geometric%20patterns%2C%20positive%20and%20trustworthy%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-exp-01&orientation=landscape',
  'article-mobile-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20mobile%20phone%20and%20app%20themed%20illustration%2C%20warm%20amber%20and%20cream%20gradients%2C%20geometric%20clean%20design%2C%20modern%20tech%20corporate%20style%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-mobile-01&orientation=landscape',
  'article-phishing-01': 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20warning%20and%20security%20themed%20illustration%20with%20warm%20golden%20and%20amber%20tones%2C%20geometric%20patterns%2C%20alert%20but%20calm%20mood%2C%20no%20text%2C%20no%20people&width=600&height=375&seq=article-phishing-01&orientation=landscape',
};

export default function Articles() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div className="pt-16">
        <Breadcrumb />
      </div>

      <main>
        <section className="w-full bg-background-50 py-12 md:py-16">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
                {arts.title}
              </h1>
              <p className="text-foreground-500 text-sm md:text-base">{arts.subtitle}</p>
            </div>

            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/articles/${article.slug}`}
                    className="group rounded-xl bg-background-100/80 overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300"
                  >
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={articleImages[article.imageSeq]}
                        alt={article.title}
                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-3 flex-wrap">
                        <span className="text-xs px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                          {article.categoryName}
                        </span>
                        <span className="text-xs text-foreground-400">{article.publishedAt}</span>
                        <span className="text-xs text-foreground-300">·</span>
                        <span className="text-xs text-foreground-400">{article.readCount.toLocaleString()} {arts.readCount}</span>
                      </div>
                      <h2 className="font-heading font-semibold text-foreground-900 mb-2 text-base leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">{article.summary}</p>
                      <div className="flex items-center gap-1.5 mt-3 flex-wrap">
                        {article.tags.map((tag) => (
                          <span key={tag} className="text-xs px-2 py-0.5 rounded bg-background-200 text-foreground-500">
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 mx-auto mb-4">
                  <i className="ri-inbox-line text-foreground-300 text-2xl" />
                </div>
                <p className="text-foreground-400 text-sm">{arts.noArticles}</p>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}